import React from "react";
import { Button } from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

export const LinkButton = ({ children, href, disabled, small, sx }) => {
  return (
    <a href={href} target="_blank" rel="noreferrer">
      <Button
        variant="text"
        disabled={disabled}
        sx={{
          color: (theme) => theme.palette.link.dark,
          alignItems: small ? "center" : "flex-start",
          padding: 0,
          fontSize: small ? "15px" : "17px",
          fontWeight: small ? "400" : "500",

          ":hover": {
            background: "none",
            color: (theme) => theme.palette.link.hover,
          },

          ":disabled": {
            color: (theme) => theme.palette.link.hover,
          },

          span: {
            marginRight: 0,
            marginLeft: "-11px",
          },

          ...sx,
        }}
        startIcon={
          <ArrowRightIcon
            sx={{
              width: "30px",
              height: "30px",
            }}
          />
        }
      >
        {children}
      </Button>
    </a>
  );
};
